import instance from "./auth";

export const getAllTemplates = async () => {
    const {data: result} = await instance.get("/templates");
    return result;
}

export const getTemplatesByType = async (type) => {
    const {data: result} = await instance.get(`/templates/${type}/list`);
    return result;
}

export const getTemplateById = async (id) => {
    const {data: result} = await instance.get(`/templates/${id}`);
    return result;
}

export const createTemplate = async (data) => {
    const {data: result} = await instance.post("/templates", data);
    return result;
}

export const updateTemplate = async (id, data) => {
    const {data: result} = await instance.put(`/templates/${id}`, data);
    return result;
}

export const deleteTemplate = async (id) => {
    const {data: result} = await instance.delete(`/templates/${id}`);
    return result;
}

